// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* new */
.SideBar-sideMenuContent-HZTom {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
	width: 100%;
}
.SideBar-sideMenuBody-GpcgT {
	padding-bottom: 80px;
	height: 100%;
	-webkit-box-flex: 1;
	    -ms-flex-positive: 1;
	        flex-grow: 1;
	overflow-y: auto;
}
.SideBar-siteAdminHeader-Ek8lW {
	position: relative;
	padding: 24px;
	text-align: center;
	color: var(--sideMenu-primary-foreground);
	font-size: 20px;
	font-weight: 600;
	line-height: 30px;
	margin-bottom: 24px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
	gap: 16px;
}
.SideBar-siteAdminHeaderUnderLine-yDxa4 {
	position: absolute;
	max-width: 200px;
	width: 100%;
	bottom: 0;
	left: 50%;
	-webkit-transform: translateX(-50%);
	    -ms-transform: translateX(-50%);
	        transform: translateX(-50%);
}
.SideBar-sideMenuGroupCaptionText-OxdfL {
	font-size: 16px;
	line-height: 24px;
	font-weight: 500;
	word-break: break-word;
	text-align: start;
	color: var(--sideMenu-secondary-foreground);
	margin-top: 24px;
	margin-bottom: 8px;
	padding: 0 16px;
}
.SideBar-sideMenuList-xeC61,
.SideBar-sideMenuListAccordionBtn-_7OeN,
.SideBar-sideMenuListAccordionCollapseList-_MjlH {
	padding: 12px 16px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: start;
	    -ms-flex-align: start;
	        align-items: flex-start;
	margin-bottom: 4px;
	gap: 8px;
	color: var(--sideMenu-primary-foreground) !important;
	text-decoration: none;
	text-align: start;
	position: relative;
	width: 100%;
	border: none;
	border-radius: 4px;
	background: transparent;
	border-width: 0 0 0 4px;
	border-style: solid;
	border-color: transparent;
	white-space: normal;
}
.SideBar-sideMenuListAccordionCollapseList-_MjlH {
	padding: 8px 24px;
}
.SideBar-sideMenuListAccordionBtn-_7OeN {
	outline: unset !important;
	background-color: unset;
}
.SideBar-sideMenuList-xeC61:hover,
.SideBar-sideMenuList-xeC61:focus,
.SideBar-sideMenuListActive-pkOqe,
.SideBar-sideMenuListActive-pkOqe:hover,
.SideBar-sideMenuListActive-pkOqe:focus,
.SideBar-sideMenuListAccordionBtn-_7OeN:hover,
.SideBar-sideMenuListAccordionBtn-_7OeN:focus,
.SideBar-sideMenuListAccordionCollapseList-_MjlH:hover,
.SideBar-sideMenuListAccordionCollapseList-_MjlH:focus {
	background: var(--sideMenu-hover-bg);
	color: var(--sideMenu-primary-foreground) !important;
	text-decoration: none;
	border-width: 0 0 0 4px;
	border-style: solid;
	border-color: var(--sideMenu-active-border);
}
.SideBar-sideMenuItemIconContainer-qycfr,
.SideBar-sideMenuListAccordionBtnIconContainer-JyWHZ,
.SideBar-sideMenuListAccordionBtnArrow-CP4zJ,
.SideBar-sideMenuListAccordionCollapseListIcon-jZhPK {
	-ms-flex-negative: 0;
	    flex-shrink: 0;
	position: relative;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
}
.SideBar-sideMenuItemIconContainer-qycfr svg,
.SideBar-sideMenuListAccordionBtnIconContainer-JyWHZ svg,
.SideBar-sideMenuListAccordionBtnArrow-CP4zJ svg,
.SideBar-sideMenuListAccordionCollapseListIcon-jZhPK svg {
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
	-o-object-fit: contain;
	   object-fit: contain;
	-o-object-position: center;
	   object-position: center;
	-webkit-transition: all .3s linear;
	transition: all .3s linear;
}
.SideBar-sideMenuItemIconContainer-qycfr,
.SideBar-sideMenuListAccordionBtnIconContainer-JyWHZ {
	top: 2px;
	width: 20px;
	height: 20px;
}
.SideBar-sideMenuListAccordionBtnArrow-CP4zJ,
.SideBar-sideMenuListAccordionCollapseListIcon-jZhPK {
	top: 4px;
	width: 16px;
	height: 16px;
}
.SideBar-sideMenuListAccordionBtnActiveArrow-kxd1T svg {
	-webkit-transform: rotate(180deg);
	    -ms-transform: rotate(180deg);
	        transform: rotate(180deg);
	-webkit-transition: all .3s linear;
	transition: all .3s linear;
}
.SideBar-sideMenuItemTextContainer-CnbIe,
.SideBar-sideMenuListAccordionBtnTextContainer-ipOsB,
.SideBar-sideMenuListAccordionCollapseListText-lj8qh {
	-webkit-box-flex: 1;
	    -ms-flex-positive: 1;
	        flex-grow: 1;
	word-break: break-word;
	font-size: 15px;
	font-weight: 400;
	line-height: 24px;
}
.SideBar-sideMenuHeaderLogoContainer-P1F_h {
	position: relative;
	width: 100%;
	max-width: 154px;
	height: 55px;
}
.SideBar-sideMenuHeaderLogo-M3VsN,
.SideBar-sideMenuHeaderLogo-M3VsN img {
	position: absolute;
	width: 100%;
	height: 100%;
	inset: 0;
}
.SideBar-sideMenuHeaderLogo-M3VsN img {
	-o-object-fit: contain;
	   object-fit: contain;
	-o-object-position: center;
	   object-position: center;
}
.SideBar-sideMenuHeaderLogoText-ndzo9,
.SideBar-sideMenuHeaderLogoText-ndzo9:hover,
.SideBar-sideMenuHeaderLogoText-ndzo9:focus {
	font-size: 18px;
	font-weight: 500;
	line-height: 28px;
	text-decoration: none;
	white-space: pre-line;
	word-break: break-word;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/SideBar/SideBar.css"],"names":[],"mappings":"AAAA,QAAQ;AACR;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;CACtB,WAAW;AACZ;AAEA;CACC,oBAAoB;CACpB,YAAY;CACZ,mBAAY;KAAZ,oBAAY;SAAZ,YAAY;CACZ,gBAAgB;AACjB;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,kBAAkB;CAClB,yCAAyC;CACzC,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,mBAAmB;CACnB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;CACtB,SAAS;AACV;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,WAAW;CACX,SAAS;CACT,SAAS;CACT,mCAA2B;KAA3B,+BAA2B;SAA3B,2BAA2B;AAC5B;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,sBAAsB;CACtB,iBAAiB;CACjB,2CAA2C;CAC3C,gBAAgB;CAChB,kBAAkB;CAClB,eAAe;AAChB;AAEA;;;CAGC,kBAAkB;CAClB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,kBAAkB;CAClB,QAAQ;CACR,oDAAoD;CACpD,qBAAqB;CACrB,iBAAiB;CACjB,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,uBAAuB;CACvB,uBAAuB;CACvB,mBAAmB;CACnB,yBAAyB;CACzB,mBAAmB;AACpB;AAEA;CACC,iBAAiB;AAClB;AAEA;CACC,yBAAyB;CACzB,uBAAuB;AACxB;AAEA;;;;;;;;;CASC,oCAAoC;CACpC,oDAAoD;CACpD,qBAAqB;CACrB,uBAAuB;CACvB,mBAAmB;CACnB,2CAA2C;AAC5C;AAEA;;;;CAIC,oBAAc;KAAd,cAAc;CACd,kBAAkB;CAClB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;AACxB;AAEA;;;;CAIC,kBAAkB;CAClB,QAAQ;CACR,WAAW;CACX,YAAY;CACZ,sBAAmB;IAAnB,mBAAmB;CACnB,0BAAuB;IAAvB,uBAAuB;CACvB,kCAA0B;CAA1B,0BAA0B;AAC3B;AAEA;;CAEC,QAAQ;CACR,WAAW;CACX,YAAY;AACb;AAEA;;CAEC,QAAQ;CACR,WAAW;CACX,YAAY;AACb;AAEA;CACC,iCAAyB;KAAzB,6BAAyB;SAAzB,yBAAyB;CACzB,kCAA0B;CAA1B,0BAA0B;AAC3B;AAEA;;;CAGC,mBAAY;KAAZ,oBAAY;SAAZ,YAAY;CACZ,sBAAsB;CACtB,eAAe;CACf,gBAAgB;CAChB,iBAAiB;AAClB;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,gBAAgB;CAChB,YAAY;AACb;AAEA;;CAEC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,QAAQ;AACT;AAEA;CACC,sBAAmB;IAAnB,mBAAmB;CACnB,0BAAuB;IAAvB,uBAAuB;AACxB;AAEA;;;CAGC,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,qBAAqB;CACrB,qBAAqB;CACrB,sBAAsB;AACvB","sourcesContent":["/* new */\n.sideMenuContent {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n}\n\n.sideMenuBody {\n\tpadding-bottom: 80px;\n\theight: 100%;\n\tflex-grow: 1;\n\toverflow-y: auto;\n}\n\n.siteAdminHeader {\n\tposition: relative;\n\tpadding: 24px;\n\ttext-align: center;\n\tcolor: var(--sideMenu-primary-foreground);\n\tfont-size: 20px;\n\tfont-weight: 600;\n\tline-height: 30px;\n\tmargin-bottom: 24px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex-direction: column;\n\tgap: 16px;\n}\n\n.siteAdminHeaderUnderLine {\n\tposition: absolute;\n\tmax-width: 200px;\n\twidth: 100%;\n\tbottom: 0;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n}\n\n.sideMenuGroupCaptionText {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 500;\n\tword-break: break-word;\n\ttext-align: start;\n\tcolor: var(--sideMenu-secondary-foreground);\n\tmargin-top: 24px;\n\tmargin-bottom: 8px;\n\tpadding: 0 16px;\n}\n\n.sideMenuList,\n.sideMenuListAccordionBtn,\n.sideMenuListAccordionCollapseList {\n\tpadding: 12px 16px;\n\tdisplay: flex;\n\talign-items: flex-start;\n\tmargin-bottom: 4px;\n\tgap: 8px;\n\tcolor: var(--sideMenu-primary-foreground) !important;\n\ttext-decoration: none;\n\ttext-align: start;\n\tposition: relative;\n\twidth: 100%;\n\tborder: none;\n\tborder-radius: 4px;\n\tbackground: transparent;\n\tborder-width: 0 0 0 4px;\n\tborder-style: solid;\n\tborder-color: transparent;\n\twhite-space: normal;\n}\n\n.sideMenuListAccordionCollapseList {\n\tpadding: 8px 24px;\n}\n\n.sideMenuListAccordionBtn {\n\toutline: unset !important;\n\tbackground-color: unset;\n}\n\n.sideMenuList:hover,\n.sideMenuList:focus,\n.sideMenuListActive,\n.sideMenuListActive:hover,\n.sideMenuListActive:focus,\n.sideMenuListAccordionBtn:hover,\n.sideMenuListAccordionBtn:focus,\n.sideMenuListAccordionCollapseList:hover,\n.sideMenuListAccordionCollapseList:focus {\n\tbackground: var(--sideMenu-hover-bg);\n\tcolor: var(--sideMenu-primary-foreground) !important;\n\ttext-decoration: none;\n\tborder-width: 0 0 0 4px;\n\tborder-style: solid;\n\tborder-color: var(--sideMenu-active-border);\n}\n\n.sideMenuItemIconContainer,\n.sideMenuListAccordionBtnIconContainer,\n.sideMenuListAccordionBtnArrow,\n.sideMenuListAccordionCollapseListIcon {\n\tflex-shrink: 0;\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.sideMenuItemIconContainer svg,\n.sideMenuListAccordionBtnIconContainer svg,\n.sideMenuListAccordionBtnArrow svg,\n.sideMenuListAccordionCollapseListIcon svg {\n\tposition: absolute;\n\tinset: 0;\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: contain;\n\tobject-position: center;\n\ttransition: all .3s linear;\n}\n\n.sideMenuItemIconContainer,\n.sideMenuListAccordionBtnIconContainer {\n\ttop: 2px;\n\twidth: 20px;\n\theight: 20px;\n}\n\n.sideMenuListAccordionBtnArrow,\n.sideMenuListAccordionCollapseListIcon {\n\ttop: 4px;\n\twidth: 16px;\n\theight: 16px;\n}\n\n.sideMenuListAccordionBtnActiveArrow svg {\n\ttransform: rotate(180deg);\n\ttransition: all .3s linear;\n}\n\n.sideMenuItemTextContainer,\n.sideMenuListAccordionBtnTextContainer,\n.sideMenuListAccordionCollapseListText {\n\tflex-grow: 1;\n\tword-break: break-word;\n\tfont-size: 15px;\n\tfont-weight: 400;\n\tline-height: 24px;\n}\n\n.sideMenuHeaderLogoContainer {\n\tposition: relative;\n\twidth: 100%;\n\tmax-width: 154px;\n\theight: 55px;\n}\n\n.sideMenuHeaderLogo,\n.sideMenuHeaderLogo img {\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\tinset: 0;\n}\n\n.sideMenuHeaderLogo img {\n\tobject-fit: contain;\n\tobject-position: center;\n}\n\n.sideMenuHeaderLogoText,\n.sideMenuHeaderLogoText:hover,\n.sideMenuHeaderLogoText:focus {\n\tfont-size: 18px;\n\tfont-weight: 500;\n\tline-height: 28px;\n\ttext-decoration: none;\n\twhite-space: pre-line;\n\tword-break: break-word;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sideMenuContent": `SideBar-sideMenuContent-HZTom`,
	"sideMenuBody": `SideBar-sideMenuBody-GpcgT`,
	"siteAdminHeader": `SideBar-siteAdminHeader-Ek8lW`,
	"siteAdminHeaderUnderLine": `SideBar-siteAdminHeaderUnderLine-yDxa4`,
	"sideMenuGroupCaptionText": `SideBar-sideMenuGroupCaptionText-OxdfL`,
	"sideMenuList": `SideBar-sideMenuList-xeC61`,
	"sideMenuListAccordionBtn": `SideBar-sideMenuListAccordionBtn-_7OeN`,
	"sideMenuListAccordionCollapseList": `SideBar-sideMenuListAccordionCollapseList-_MjlH`,
	"sideMenuListActive": `SideBar-sideMenuListActive-pkOqe`,
	"sideMenuItemIconContainer": `SideBar-sideMenuItemIconContainer-qycfr`,
	"sideMenuListAccordionBtnIconContainer": `SideBar-sideMenuListAccordionBtnIconContainer-JyWHZ`,
	"sideMenuListAccordionBtnArrow": `SideBar-sideMenuListAccordionBtnArrow-CP4zJ`,
	"sideMenuListAccordionCollapseListIcon": `SideBar-sideMenuListAccordionCollapseListIcon-jZhPK`,
	"sideMenuListAccordionBtnActiveArrow": `SideBar-sideMenuListAccordionBtnActiveArrow-kxd1T`,
	"sideMenuItemTextContainer": `SideBar-sideMenuItemTextContainer-CnbIe`,
	"sideMenuListAccordionBtnTextContainer": `SideBar-sideMenuListAccordionBtnTextContainer-ipOsB`,
	"sideMenuListAccordionCollapseListText": `SideBar-sideMenuListAccordionCollapseListText-lj8qh`,
	"sideMenuHeaderLogoContainer": `SideBar-sideMenuHeaderLogoContainer-P1F_h`,
	"sideMenuHeaderLogo": `SideBar-sideMenuHeaderLogo-M3VsN`,
	"sideMenuHeaderLogoText": `SideBar-sideMenuHeaderLogoText-ndzo9`
};
module.exports = ___CSS_LOADER_EXPORT___;
